import {Suspense, lazy} from 'react'
import Loader from "../../customs/loader/main"

const Main = lazy(() => import("../../components/settings/Setups/electoralPosition/main"))

const ElectoralPosition = () => {
  return (
    // <Layout >
        <Suspense fallback={<Loader />}> 
        <Main />
    </Suspense>
    // </Layout>
    
  )
}
export default ElectoralPosition